import React, { Component } from 'react';
import './TermsOfService.css';
import { NavItem, NavLink, Nav } from 'reactstrap';
import { Link } from 'react-router-dom'

class TermsOfService extends Component {

    constructor(props){
        super(props);
    }

    componentDidMount() {
        document.title = 'Terms Of Service';
    }

    render () {
          return (
            <div>
              <div> 
                    <NavLink style={{position:'fixed', fontSize:'30px', padding:'15px 30px', color:'white', width:'100%', background: '#333F50'}} tag={Link} to={'/login'}>
                                                swipequotes
                                                </NavLink>
                </div>
            <div className="termsOfServiceContainer">
            <div className="termsOfServiceHeader"> Terms Of Service</div>
            <p>The services are provided by Swipenine Private Limited (parent company and hereinafter referred to as “SwipeQuotes”), an Indian company with registered address at 65/2593, Second Floor, GECO Complex, Nadakkavu, Calicut, Kerala, India 673011.<br></br>
              Please follow all the policies with respect to SwipeQuotes. The SwipeQuotes Content Policy are subject to change thus please review the policies periodically and it’s applicable to website and apps respectively.<br></br>
              We do not permit misuse of services rendered by SwipeQuotes. Using our services, do not permit the user, ownership in the services and content that you access. SwipeQuotes branding and logo are exclusive property of SwipeQuotes and you do not have the right to use the same.<br></br>
              As a part of the user service- announcements, administrative messages, and other information may be communicated to users.<br></br>
            </p>
            <div className="termsOfServiceSubHeader">Acceptance of Terms</div>
            <p>
              By accessing or using SwipeQuotes, you confirm that you are at least 12 years old and capable of entering a legally binding agreement. If you are using the Service on behalf of an organization, you represent that you have full authority to do so.
            </p>
            <div className="termsOfServiceSubHeader">Description of Service</div>
            <p>
              SwipeQuotes is a platform that provides inspirational quotes, original writings, celebration messages, educational content, and related media. Users may view, save, share, and interact with content subject to these Terms.
            </p>
            <div className="termsOfServiceSubHeader">User Responsibilities</div>
            <p>
              Users agree not to:<br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Use the Service for any unlawful, harmful, or abusive purpose.</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Share content that is defamatory, hateful, offensive, or violates intellectual property rights.</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Attempt to hack, disrupt, or interfere with the Service or its security.</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Use automated tools (bots, scrapers, crawlers) without permission.</span><br></br>
              Violation of these rules may result in account suspension or termination.
            </p>
            <div className="termsOfServiceSubHeader">User Accounts</div>
            <p>
              For certain features, you may need to create an account. You agree to:<br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Provide accurate information.</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Maintain the confidentiality of your login credentials.</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Be responsible for all activity under your account.</span><br></br>
              We reserve the right to refuse or terminate accounts at our discretion.
            </p>
            <div className="termsOfServiceSubHeader">Intellectual Property</div>
            <p>
              All content on SwipeQuotes—text, graphics, images, designs, UI elements, logos, and software—is the property of SwipeQuotes or its content creators and is protected by copyright, trademark, and intellectual property laws.<br></br>
              You may:<br></br>
              <span style={{padding: "0 0 0 10px"}}>•	View content for personal and non-commercial use.</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Share content with proper attribution.</span><br></br>
              You may NOT:<br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Copy, reproduce, resell, or modify content for commercial purposes without written permission.</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Claim any SwipeQuotes content as their own.</span>
            </p>
            <div className="termsOfServiceSubHeader">User-Generated Content</div>
            <p>
              If you submit or publish content (quotes, comments, suggestions, etc.), you grant SwipeQuotes a non-exclusive, worldwide, royalty-free license to use, display, reproduce, and distribute the content for platform functionality and promotion.<br></br>
              You are solely responsible for ensuring your submissions:<br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Do not infringe on any third-party rights.</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Are lawful and appropriate.</span><br></br>
              We reserve the right to remove any content at our discretion.
            </p>
            <div className="termsOfServiceSubHeader">Third-Party Links & Services</div>
            <p>
              SwipeQuotes may contain links to third-party services or ads. We are not responsible for their content, accuracy, or policies. Use at your own discretion.
            </p>
            <div className="termsOfServiceSubHeader">Privacy Policy</div>
            <p>
              Use of SwipeQuotes is also governed by our Privacy Policy, which describes how personal data is collected, used, and protected. You agree to review the Privacy Policy regularly.
            </p>
            <div className="termsOfServiceSubHeader">Disclaimer of Warranties</div>
            <p>
              The Service is provided <span style={{fontWeight: "bold"}}>“as is” and “as available.”</span><br></br>
              SwipeQuotes makes no warranties, express or implied, regarding accuracy, reliability, availability, security, or suitability of content.<br></br>
              Use of the Service is at your own risk.
            </p>
            <div className="termsOfServiceSubHeader">Limitation of Liability</div>
            <p>
              SwipeQuotes and its team are not liable for:<br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Any damages caused by interruption, suspension, or inability to use the Service.</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Loss of data, profits, reputation, or emotional impact from content.</span><br></br>
              <span style={{padding: "0 0 0 10px"}}>•	Third-party actions or unauthorized access.</span><br></br>
              Our maximum liability shall not exceed the amount you paid to us (if any)..
            </p>
            <div className="termsOfServiceSubHeader">Payment Policy</div>
            <p>
              Any payments in connection with the services will be paid to user after due verification and diligence. The user does not have any right to claim any amount as rewards, remuneration or any other claims in connection with terms of engagement with the SwipeQuotes Team. It will be under the sole discretion and right of SwipeQuotes Team to pay any rewards, remuneration or any other payments if any to the users.
            </p>
            <div className="termsOfServiceSubHeader">Cancellation / Refund Policy</div>
            <p>
              Please note that you will not receive a refund of any amount paid. In short, all sales are final and no refund will be issued for any kind of payments made to swipequotes, adsquare, subsidiary projects or websites linked with swipequotes project or THE S9 GRID Community. For one time payments, there will be having a validity till the termination of project or services and will not be considered as a lifetime payment by any means. For cancelled subscriptions which are being paid on a monthly or annual basis, billing will stop after the existing subscription period. Also we do not offer refunds or credits for unused subscription periods, accidental purchases or any similar reasons or events.<br></br>
              By making a purchase on the swipequotes, Adsquare facility or associated platforms with swipequotes or THE S9 GRID Community, you acknowledge that you have read and agree to the No Refund Policy. We do not provide any warranty to the services offered as the service provided is “AS IS”. Payment processing fee will be dependent on the currency selected by the user and as per the conditions of the payment gateway provider. You are responsible for any currency exchange taxes, fees, or other costs that may incur by making a purchase of our services.
            </p>
            <div className="termsOfServiceSubHeader">Tax Information</div>
            <p>
              We collect tax identification information and report this to tax authorities as legally required. You are solely responsible for reporting any income or withholding taxes which may be due as a result of payments received.
            </p>
            <div className="termsOfServiceSubHeader">Modifications to Service</div>
            <p>
              We reserve the right to update, change, or discontinue any part of the Service at any time without notice.
            </p>
            <div className="termsOfServiceSubHeader">Changes & Updates to Terms</div>
            <p>
              These Terms may be updated periodically. Continued use of the Service after updates means acceptance of the revised Terms. We recommend checking periodically. A user must be cognizant of the terms and changes on a regular basis. If you do not agree with the terms and policies, please discontinue the services.
            </p>
            <div className="termsOfServiceSubHeader">Termination</div>
            <p>
              We may suspend or terminate access without notice if you violate these Terms. Upon termination, rights granted to you will end immediately.
            </p>
            <div className="termsOfServiceSubHeader">Governing Law</div>
            <p>
              If there is a conflict between the terms and additional terms, the additional terms will supersede previous terms. SwipeQuotes terms only govern relationship between you as a user and SwipeQuotes, there is no scope for third party to interfere in the same.
            </p>
            <div className="termsOfServiceSubHeader">Contact Information</div>
            <p>
              You can drop in a mail to <a href=''>swipenine@outlook.com</a><br></br>
              We usually respond in a few hours..<br></br><br></br>
              Last Updated : 04 January 2026

            </p>
          </div>
          <div className='termsOfServiceFooter'>
                    <Nav horizontal className="list-unstyled pb-3">
                        <NavItem>
                            <NavLink tag={Link} to={'/login'}>
                            Home
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/aboutUs'}>
                            About Us
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/termsOfService'}>
                            Terms of Service
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/privacyPolicy'}>
                            Privacy & Content Policy
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/questions'}>
                            Have Questions ?
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/connect'}>
                            Connect with Us
                            </NavLink>
                        </NavItem>
                    </Nav>
                </div>
          </div>
            
          )
    }
  }
  
  export default TermsOfService